import { Link } from "react-router-dom";

export const AcornJar = ({ jar, testId = "acorn-jar" }) => (
  <Link to="/rewards" className="pp-jar" data-testid={testId} title="Acorns earned. Tap to see rewards">
    <img src="/acorn-t.png" alt="" />
    <span data-testid={`${testId}-total`}>{jar.total}</span>
    {jar.golden > 0 && <span className="pp-jar-gold" data-testid={`${testId}-golden`}>{jar.golden} golden</span>}
  </Link>
);
